<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">… and those who fear life are already three parts dead.</p>
<p class="ded1-2"><span>—Bertrand Russell</span></p>
<p class="ded2">… and I guess it isn’t too important now that they all die. I will be satisfied to make them three parts dead.</p>
<p class="ded1-2"><span>—Mack Bolan, THE EXECUTIONER</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7f41f07d